export default {
  'imagery.title': 'Vehicle imagery',
  'imagery.products': 'Products',
  'imagery.product': 'Product',
  'imagery.batches': 'Daily batches',
  'imagery.batch': 'Daily batch',
  'imagery.record': 'Generation record',
  'imagery.generationSummary': 'Generation summary',
  'imagery.generatedImages': 'Generated images',
  'imagery.currentImage': 'Current image',
  'imagery.outlineImage': 'Outline image',
  'imagery.greyImage': 'Grey image',
  'imagery.variantResults': 'Style results',
  'imagery.retryVariant': 'Retry {style} image',
  'imagery.confirmVariant': 'Confirm retry',
  'imagery.confirmVariantTitle': 'Retry {style} for {product}?',
  'imagery.confirmVariantDescription':
    'Generate a new {style} image from the current source revision.',
  'imagery.variantMissing': '{style} image not generated',
  'imagery.generationPaused': 'Image generation is paused.',
  'imagery.customerGenerationDisabled':
    'Image generation is disabled for this customer.',
  'imagery.providerNotConfigured': 'Image generation is not configured.',
  'imagery.variantSourceUnavailable':
    'The source image or its vehicle information is no longer available for generation.',
  'imagery.variantConsistencyRejected': 'The image does not match its source.',
  'imagery.variantInterrupted':
    'Image generation was interrupted. Review the result before retrying.',
  'imagery.variantUnknownOutcome':
    'The generation outcome is unknown and may already have incurred charges.',
  'imagery.variantRequestLimit': 'The model request limit has been reached.',
  'imagery.variantProcessingFailed': 'The image could not be generated.',
  'imagery.variantRetryUnavailable':
    'Retry is unavailable. Refresh the Product details.',
  'imagery.variantSourceChanged':
    'This source revision is no longer current. Open the Product to review its current image.',
  'imagery.variantPending': 'Image generation is already in progress.',
  'imagery.variantUnsupported':
    'This stored style is available for review only.',
  'imagery.variantAvailable': 'An image is already available for this style.',
  'imagery.variantSourceRequired':
    'A published current source image is required.',
  'imagery.variantProductUnavailable':
    'This Product is no longer available for generation.',
  'imagery.variantPendingCount': '{style} pending',
  'imagery.variantSucceededCount': '{style} completed',
  'imagery.variantFailedCount': '{style} failed',
  'imagery.variantUnknownCount': '{style} unknown',
  'imagery.variantStoppedCount': '{style} stopped',
  'imagery.style': 'Style',
  'imagery.style.outline': 'Outline',
  'imagery.style.studio-grey': 'Studio grey',
  'imagery.sourceRevision': 'Source revision',
  'imagery.recipeVersion': 'Recipe version',
  'imagery.outlineStatus': 'Outline publication',
  'imagery.greyMissing': 'Grey image not generated',
  'imagery.outlineMissing': 'No outline image',
  'imagery.sourceOutline': 'Source outline',
  'imagery.errorCode': 'Error code',
  'imagery.retryGrey': 'Retry grey image',
  'imagery.confirmGrey': 'Confirm grey retry',
  'imagery.confirmGreyTitle': 'Retry grey image for {product}?',
  'imagery.confirmGreyDescription':
    'Generate a new grey image from the current outline. The outline image will not be regenerated.',
  'imagery.greyPending': 'Grey pending',
  'imagery.greySucceeded': 'Grey completed',
  'imagery.greyFailed': 'Grey failed',
  'imagery.greyUnknown': 'Grey unknown',
  'imagery.greyStopped': 'Grey stopped',
  'imagery.outlineCandidates': 'Outline candidates',
  'imagery.fullGeneration':
    'Research and confirm the vehicle identity before generating an outline and its grey image. If identity is unresolved or conflicting, the run stops without generating an image. Research usage still applies, and the run is not automatically retried.',
  'imagery.currentRevision': 'Current revision',
  'imagery.productInformation': 'Product information',
  'imagery.imageInformation': 'Image information',
  'imagery.generationHistory': 'Generation history',
  'imagery.imageHistory': 'Image history',
  'imagery.productCode': 'Product code',
  'imagery.productDescription': 'Product description',
  'imagery.qualifyingStock': 'Qualifying Stock',
  'imagery.customer': 'Customer',
  'imagery.customerGeneration': 'Vehicle image generation',
  'imagery.allCustomers': 'All selected customers',
  'imagery.manufacturer': 'Manufacturer',
  'imagery.source': 'Source',
  'imagery.revision': 'Revision {revision}',
  'imagery.publishedAt': 'Published at',
  'imagery.score': 'Quality score',
  'imagery.belowThreshold': 'Below threshold',
  'imagery.belowThresholdScore': 'Quality score: {score}/100. Target: 95.',
  'imagery.status': 'Status',
  'imagery.allStatuses': 'All statuses',
  'imagery.actions': 'Actions',
  'imagery.search': 'Search products',
  'imagery.generate': 'Generate',
  'imagery.regenerate': 'Regenerate',
  'imagery.generating': 'Generating',
  'imagery.pending': 'Queued',
  'imagery.noImage': 'No current image',
  'imagery.generated': 'Computer-generated representative image',
  'imagery.inputTokens': 'Input tokens',
  'imagery.outputTokens': 'Output tokens',
  'imagery.model': 'Model',
  'imagery.step': 'Step',
  'imagery.duration': 'Duration',
  'imagery.unsupportedSource': 'Preview unavailable for this image source',
  'imagery.previewUnavailable': 'Image unavailable',
  'imagery.unknown': 'Unknown',
  'imagery.notAvailable': 'Not available',
  'imagery.confirm': 'Confirm generation',
  'imagery.confirmTitle': 'Generate image for {product}?',
  'imagery.confirmReplacement':
    'The current image remains available until an identity-qualified replacement is published. A quality score below 95 does not prevent a qualified replacement.',
  'imagery.confirmNew':
    'The best available identity-qualified image is published, even if its quality score is below 95.',
  'imagery.confirmQuota':
    'This request uses the shared daily Product-run limit when it starts. It may wait for a later UTC day.',
  'imagery.reason': 'Reason',
  'imagery.unknownWarning':
    'The previous run has an unknown outcome and may already have incurred charges.',
  'imagery.unknownAcknowledge':
    'I understand that this new run can incur additional charges.',
  'imagery.requestFailed':
    'The request could not be confirmed. Retry this request to check the same submission.',
  'imagery.requestConflict':
    'This Product has changed or already has a pending run. Refresh its details before generating again.',
  'imagery.requestDenied': 'Generation is not permitted for this Product.',
  'imagery.cancel': 'Cancel',
  'imagery.refresh': 'Refresh',
  'imagery.loadError': 'Vehicle imagery could not be loaded.',
  'imagery.apiUnavailable':
    'Vehicle imagery is unavailable in this API version.',
  'imagery.run': 'Run',
  'imagery.origin': 'Origin',
  'imagery.requestedBy': 'Requested by',
  'imagery.requestedAt': 'Requested at',
  'imagery.startedAt': 'Started at',
  'imagery.completedAt': 'Completed at',
  'imagery.output': 'Output',
  'imagery.result': 'Result',
  'imagery.resultReason': 'Result reason',
  'imagery.productResults': 'Product results',
  'imagery.considered': 'Considered',
  'imagery.started': 'Started runs',
  'imagery.published': 'Published',
  'imagery.rejected': 'Rejected',
  'imagery.failed': 'Failed',
  'imagery.stopped': 'Stopped',
  'imagery.skipped': 'Skipped',
  'imagery.deferred': 'Deferred',
  'imagery.noPaidRun': 'No paid run',
  'imagery.noPublishedOutput': 'No image published by this run',
  'imagery.generationDetails': 'Generation details',
  'imagery.candidates': 'Candidates',
  'imagery.candidate': 'Candidate {number}',
  'imagery.selectedCandidate': 'Selected candidate',
  'imagery.selected': 'Selected',
  'imagery.publishedCandidate': 'Published candidate',
  'imagery.accepted': 'Accepted',
  'imagery.unpublished': 'Unpublished candidate',
  'imagery.identitySummary': 'AI identity summary',
  'imagery.suspendImage': 'Suspend image',
  'imagery.suspendTitle': 'Suspend the current image?',
  'imagery.confirmSuspension': 'Confirm suspension',
  'imagery.suspendDescription':
    'Stop using this generated revision on ordinary vehicle pages and exports. Existing real photos or placeholders will be used. The image, generation history and usage remain available to administrators. No replacement is generated and no model call is made.',
  'imagery.suspendAcknowledge':
    'I confirm this current image should no longer be displayed.',
  'imagery.imageSuspended': 'Suspended from ordinary display',
  'imagery.suspendConflict':
    'The current image changed or generation is active. Close this dialog and refresh before reviewing the image again.',
  'imagery.suspendDenied': 'You do not have permission to suspend this image.',
  'imagery.suspendFailed':
    'Suspension could not be confirmed. Refresh the Product to check its current image before submitting again.',
  'imagery.suspendUnavailable':
    'This image cannot currently be suspended. Refresh the Product details.',
  'imagery.supportingEvidence': 'Supporting evidence',
  'imagery.imageIdentityCheck': 'Image identity check',
  'imagery.observedBody': 'Observed body',
  'imagery.identityField.make': 'Make',
  'imagery.identityField.model': 'Model / generation',
  'imagery.identityField.body': 'Body',
  'imagery.qualityComponent': 'Quality component',
  'imagery.weight': 'Weight',
  'imagery.quality.identity': 'Identity and body',
  'imagery.quality.framing': 'Complete vehicle',
  'imagery.quality.geometry': 'Geometry',
  'imagery.quality.style': 'Style',
  'imagery.quality.quality': 'Overall quality',
  'imagery.qualityExplanation':
    'Quality score measures the image, not the probability that the vehicle identity is correct. Identity conflicts prevent publication at any score.',
  'imagery.identityMapping': 'VIN identity evidence',
  'imagery.mappingKind': 'Mapping method',
  'imagery.modelCode': 'Manufacturer model code',
  'imagery.applicableMarket': 'Applicable market',
  'imagery.mappingEvidence': 'Model mapping',
  'imagery.mappingRule': 'Applicable VIN rule',
  'imagery.identityEstablished': 'Identity established',
  'imagery.identityUnresolved': 'Identity unresolved',
  'imagery.identityConflict': 'Identity conflict',
  'imagery.identityLegacy': 'Legacy identity — unverified',
  'imagery.identityNotAssessed': 'Identity not assessed',
  'imagery.imageIdentityNotAssessed': 'Image identity not assessed',
  'imagery.identityNotAssessedDescription':
    'No completed identity assessment is available for this run.',
  'imagery.identityLegacyDescription':
    'This record has no identity decision under the current policy. Its historical result and score have not been recalculated.',
  'imagery.identityUnresolvedDescription':
    'Vehicle identity could not be confirmed. No image was generated. Existing images are retained; research usage still applies.',
  'imagery.identityConflictDescription':
    'Vehicle identity evidence conflicts. No image was generated. Existing images are retained; research usage still applies.',
  'imagery.sourceIdentityUnverified':
    'The source vehicle identity is unverified. Generate a new outline to research and confirm its identity before retrying this style.',
  'imagery.sourceResearchUnavailable':
    'Source research is unavailable. Regenerate the outline to establish vehicle identity.',
  'imagery.sourceImageSuspended':
    'This source image is suspended. Generate a new outline before retrying this style.',
  'imagery.evidenceQuality': 'Evidence quality',
  'imagery.publicIdentity': 'Public identity established',
  'imagery.generation': 'Generation',
  'imagery.confidence': 'Confidence',
  'imagery.uncertainty': 'Uncertainty',
  'imagery.sources': 'Sources',
  'imagery.warnings': 'Warnings',
  'imagery.checks': 'Evaluation checks',
  'imagery.hardRejection': 'Hard rejection',
  'imagery.issues': 'Issues',
  'imagery.usage': 'Usage',
  'imagery.modelRequests': 'Model requests',
  'imagery.webActions': 'Web actions',
  'imagery.estimatedCost': 'Estimated cost (USD)',
  'imagery.stageDurations': 'Stage timings',
  'imagery.currentStep': 'Current step',
  'imagery.fromDate': 'From (UTC)',
  'imagery.toDate': 'To (UTC)',
  'imagery.noRecords': 'No records',
  'imagery.historical': 'Historical revision',
  'imagery.imageVersions': 'Image versions',
  'imagery.retry': 'Retry',
};
